import { api } from './api';

export const useAccount = () => {
  const account = api.useGetAccountQuery();
  // We explicitly clear account.data on logout; otherwise, we always want to
  // continue providing even old data, as if the user is currently offline
  // a call to get `/api/v2/account` will fail but we want them to still access
  // the app! Therefore we ignore `account.isSuccess` and friends, and just
  // return the most recent successful data.
  return account.data;
};
